import React from 'react';
import closeImage from '../../../../images/icon/icon-close.svg';
import NowSignatureEuroImage from '../../../../images/get-started/packs/Now-Signature-euro2024-1000x600.jpg';
import NowSignatureEuroBannerImage from '../../../../images/get-started/packs/Now-Signature-euro2024-banner.jpg';


interface SignatureModalProps {
}

const SignatureModal: React.FC<SignatureModalProps> = () => {
    return (
<>  
        
        <div className="modal-wrapper addSignature-modal">
            <div className="modal-dialog">
              <div className="modal-content-wrapper">
                <div className="close-wrap">
                    <div className="close-btn"><button className="close-modal">Close <img src={closeImage}  alt="" /></button></div>
                </div>
                
                <div className="add-plan-wrapper">
                    <h2>Get the special combo offer</h2>
                    <h4>Save $400 for EURO Event Pass with this combo</h4>
    
                    <div className="item">
                        <img src={NowSignatureEuroImage} className="desktop" alt="" />
                        <img src={NowSignatureEuroBannerImage} className="mobile" alt="" />
                        <div className="content">
                            <div className="top">
                                <h3>Now Signature Pack + Euro 2024</h3>
                                <p>Watch LIVE matches of UEFA EURO 2024™ during Jun 15 - July 15, 2024 (discount price $580);  plus Now Signature Pack (standard price $1416) to enjoy the top-notch movies from Hong Kong and around the world, plus Asian TV series, factual, kids , live sports programmes for 12 months!</p>
                            </div>
                            
                            <div className="bottom col">
                                <div className="commitment">
                                    <div className="price">$1,996 <span style={{ textDecoration: 'line-through' }}>($2,396)</span> 
                                    </div>
                                    <small>Now Signature Pack will be subscribed automatically for 12 months at $1,416 beginning on the next day of the Pack End Date for this pack.</small>
                                </div>
                                <div className="cta-controls">
                                    <a href="https://ssp.nowtv.now.com/choose-plan?epc=NTVSSP-CGNSEURO24&lang=en" className="btn primary">Continue with this combo</a>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <div className="no-thanks">
                        <a href="https://ssp.nowtv.now.com/choose-plan?campaign=PRCALFTGD980OTTSEU24&lang=en" className="btn secondary" >Continue with Euro 2024 only</a>
                    </div>
                </div>
    
              </div>
        
            </div>
        
        </div>


    
    
        
        <div className="modal-wrapper addSignature-modal">
            <div className="modal-dialog">
              <div className="modal-content-wrapper">
                <div className="close-wrap">
                    <div className="close-btn"><button className="close-modal">關閉 <img src={closeImage} alt="" /></button></div>
                </div>
                
                <div className="add-plan-wrapper">
                    <h2>仲有特別組合優惠！</h2>
                    <h4>此組合幫你慳 $400 訂購 歐洲國家盃通行證</h4>
    
                    <div className="item">
                        <img src={NowSignatureEuroImage} className="desktop" alt="" />
                        <img src={NowSignatureEuroBannerImage} className="mobile" alt="" />
                        <div className="content">
                            <div className="top">
                                <h3>Now 皇牌娛樂組合 + 歐洲國家盃 2024</h3>
                                <p>收看歐洲國家盃於 2024年6月15日至7月15日期間賽事直播  (優惠價 $580); 及Now 皇牌娛樂組合 (正價$1416) 收看頂級精彩本地及中西電影 、亞洲劇集 、紀實、娛樂、 綜藝、動漫、兒童及體育直播節目12個月!</p>
                            </div>
                            
                            <div className="bottom col">
                                <div className="commitment">
                                    <div className="price">$1,996 <span style={{ textDecoration: 'line-through' }}>($2,396)</span></div>
                                    <small>此組合完結日之翌日將以$1,416自動續訂Now 皇牌娛樂組合12個月。</small>
                                </div>
                                <div className="cta-controls">
                                    <a href="https://ssp.nowtv.now.com/choose-plan?epc=NTVSSP-CGNSEURO24&lang=zh" className="btn primary">訂購此組合</a>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <div className="no-thanks">
                        <a href="https://ssp.nowtv.now.com/choose-plan?campaign=PRCALFTGD980OTTSEU24&lang=zh" className="btn secondary" >只訂購歐洲國家盃</a>
                    </div>
                </div>
    
              </div>
        
            </div>
        
        </div>
</>
    );
}
export default SignatureModal;